import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"
import createFromModal from "../helpers/modal_create"

// The enhancements on the Gifts & Design step of Send a Gift, and the height of
// its email preview.
//
// Every other panel on that page links out to the editor that owns it; the three
// toggles are the only thing the page saves itself, so they save as they are
// touched rather than behind a Next button. The standalone enhancements step
// is give_tracking_controller.js.
export default class extends Controller {
  static get values() {
    return { updatePath: String }
  }

  // The toggle only decides whether the picker is on screen. Turning one off
  // clears the picker, which is what actually detaches the enhancement.
  toggle(event) {
    const row = event.target.closest(".enhancement")
    const group = row.querySelector(".enhancement-actions .form-group")
    const select = row.querySelector("select")

    group.classList.toggle("hidden", !event.target.checked)

    // An empty picker only offers to create one, so there is nothing to save.
    if (!select || select.options.length < 2) {
      return
    }

    if (!event.target.checked) {
      select.value = ""
    }

    // A picker that has just appeared holds nothing yet, so there is nothing to
    // save until the sender chooses.
    if (event.target.checked && select.value === "") {
      return
    }

    this.save(select)
  }

  select(event) {
    this.save(event.target)
  }

  createCampaign(event) {
    this.create(event, { modal: "#create-campaign-modal", key: "campaign", select: "build_campaign_id" })
  }

  createScheduler(event) {
    this.create(event, { modal: "#create-scheduler-modal", key: "scheduler", select: "build_scheduler_id" })
  }

  // The frame shows the real mailer output, whose length varies with the
  // message, so it grows to fit the whole email instead of cutting it off.
  fitEmailFrame(event) {
    const doc = event.target.contentDocument

    if (doc) {
      event.target.style.height = `${doc.documentElement.scrollHeight}px`
    }
  }

  // Send only the changed picker. The others may hold a carried record they
  // can't show, and saving them would detach it.
  save(select) {
    const field = select.id.replace(/^build_/, "")
    const body = { build: { [field]: select.value } }

    fetch(this.updatePathValue, this.jsonOptions(RequestHelper.defaultPatchOptions(), body))
      .then((response) => this.parse(response))
      .then((data) => window.ltAlert({ message: data.message }))
      .catch((error) => window.ltAlert({ message: error.message, type: "toast-error" }))
  }

  create(event, { modal, key, select }) {
    createFromModal(event, {
      modal,
      key,
      onCreated: (record, form) => {
        this.showCreated(select, record)
        $(modal).modal("hide")
        form.reset()
      },
    })
  }

  showCreated(selectId, record) {
    const select = document.getElementById(selectId)
    const picker = select.closest(".picker")

    select.add(new Option(record.name, record.id, true, true))
    picker.hidden = false
    picker.parentElement.querySelector(".empty-note")?.remove()

    this.save(select)
  }

  jsonOptions(options, body) {
    return Object.assign(options, {
      headers: Object.assign({}, options.headers, { "Content-Type": "application/json" }),
      body: JSON.stringify(body),
    })
  }

  // Errors come back as JSON too, and their message is what the toast shows.
  parse(response) {
    return response.json().then((data) => {
      if (!response.ok) {
        throw new Error(data.message || "Something went wrong. Please try again.")
      }

      return data
    })
  }
}
